import React from 'react'

import { ContentState, Editor } from 'draft-js'

import { COLORS } from '~/common/globalStyles'
import { MergeTag } from '~/common/types/graphql'

import RichTextView2 from './RichTextView2'

interface RichEditorProps {
  children?: React.ReactNode
  color?: keyof typeof COLORS
  contentState?: ContentState
  disabled?: boolean
  editor?: Editor
  entityKey?: string
  innerRef?: (editor: Editor | null) => void
  mergeTags?: MergeTag[]
  mergeValues?: any
  name?: string
  noVerticalMargins?: boolean
  nowrap?: boolean
  onChange?: (param: any) => void
  placeholder?: string
  readOnly?: boolean
  rows?: number
  value?: string | null
  forceRichEditorReinitialize?: boolean
  dataTestId?: string
}

const RichTextView = (props: RichEditorProps) => {
  return (
    <RichTextView2
      dataTestId={props.dataTestId}
      value={props.value || ''}
      mergeValues={props.mergeValues || []}
    />
  )
}

export default RichTextView
